import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { MatPaginator, MatSort, MatDialog, MatSelectChange, MatDatepicker } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { startOfMonth, endOfMonth } from 'date-fns';
import { TransacsService } from './transacs.service';
import { fuseAnimations } from '../../../../core/animations';
import { WindowRef } from '../../../../core/components/window/window.service';
import { environment } from '../../../../../environments/environment';
import { FuseUtils } from '../../../../core/fuseUtils';
import { TransactionsQuery } from '../../../../core/services/transactions/transactions.model';
import { TRANS_STATUS, TRANS_TYPE } from '../../../../core/services/transactions/transaction.constants';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { toUTCSmallDate } from '../../../../core/services/dates.service';
import { VoutchersService } from '../../../../core/services/vouchers/vouchers.service';

@Component({
    selector   : 'fuse-transactions',
    templateUrl: './transactions.component.html',
    styleUrls  : ['./transactions.component.scss'],
    animations : fuseAnimations
})
export class TransactionsComponent implements OnInit
{
    dataSource: FilesDataSource | null;
    statut;
    type;
    displayedColumns = ['type', 'vads_amount', 'amountTTC', 'amountVAT', 'orderType', 'userType', 'vads_trans_status', 'createdAt'];

    statuses = [
        TRANS_STATUS.AUTHORISED,
        TRANS_STATUS.CANCELLED,
        TRANS_STATUS.CAPTURED,
        TRANS_STATUS.CAPTURE_FAILED,
        TRANS_STATUS.EXPIRED,
        TRANS_STATUS.INITIAL,
        TRANS_STATUS.REFUSED,
        TRANS_STATUS.UNDER_VERIFICATION,
        // TRANS_STATUS.WAITING_AUTHORISATION,
        // TRANS_STATUS.WAITING_AUTHORISATION_TO_VALIDATE,
    ];

    types = [
        TRANS_TYPE.CB,
        TRANS_TYPE.TPE,
        TRANS_TYPE.ESPECE,
        TRANS_TYPE.CHEQUE,
        TRANS_TYPE.CHEQUE_VACANCE,
        TRANS_TYPE.VIREMENT,
        TRANS_TYPE.BON_CADEAU,
    ];

    dialogRef: any;
    selectedDates: any;

    pageNumber = 0;
    pageLength = 0;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild('startDatePicker') startDatePicker: MatDatepicker<any>;
    @ViewChild('endDatePicker') endDatePicker: MatDatepicker<any>;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('from') fromDate: ElementRef;
    @ViewChild('to') toDate: ElementRef;

    nativeWindow: any;
    inputFrom: FormControl;
    inputTo: FormControl;

    constructor(
      private readonly winRef: WindowRef,
      public readonly dialog: MatDialog,
      readonly transacsService: TransacsService,
      public readonly vouchersService: VoutchersService,
    ) {
      this.nativeWindow = this.winRef.getNativeWindow();
      this.selectedDates = {
        from: moment().startOf('month'),
        to: moment().endOf('month'),
      };
      this.inputFrom = new FormControl(this.from);
      this.inputTo = new FormControl(this.to);
    }

    ngOnInit() {
      this.dataSource = new FilesDataSource(this.transacsService, this.paginator, this.sort);
      Observable
        .fromEvent(this.filter.nativeElement, 'keyup')
        .debounceTime(150)
        .distinctUntilChanged()
        .subscribe(() => {
          if ( !this.dataSource )
          {
            return;
          }
          this.paginator._pageIndex = 0;
          this.dataSource.filter = this.filter.nativeElement.value;
        });

        this.pageNumber = Number.parseInt(this.nativeWindow.localStorage.getItem('currentPageNumber'));
        this.pageLength = Number.parseInt(this.nativeWindow.localStorage.getItem('currentPageLength'));

        this.statut = TRANS_STATUS.AUTHORISED;
        // this.startDatePicker._select(this.selectedDates.from);
        // this.endDatePicker._select(this.selectedDates.to);
        // this.fromDate.nativeElement.value = moment(this.from).locale('fr').format('L');
        // this.toDate.nativeElement.value = moment(this.to).locale('fr').format('L');
        this.refresh();
    }

    reset() {
        this.startDatePicker._select(null);
        this.endDatePicker._select(null);
        this.fromDate.nativeElement.value = null;
        this.toDate.nativeElement.value = null;
        this.from = null;
        this.to = null;
        this.refresh();
    }

    selectChange(event: MatSelectChange) {
        // this.statut = event.value;
        this.refresh();
    }

//#region Dates

    set from(from: Date)
    {
        if (!from) {
            localStorage.removeItem('transac_from');
            return;
        }
        localStorage.setItem('transac_from', from.toISOString());
    }
    get from() {
        const val = localStorage.getItem('transac_from');
        if (val) {
            return toUTCSmallDate(val);
        }
        return toUTCSmallDate(this.selectedDates.from);
    }
    set to(to: Date)
    {
        if (!to) {
            localStorage.removeItem('transac_to');
            return;
        }
        localStorage.setItem('transac_to', to.toISOString());
    }
    get to() {
        const val = localStorage.getItem('transac_to');
        if (val) {
            return toUTCSmallDate(val);
        }
        return toUTCSmallDate(this.selectedDates.to);
    }

    changeFrom(event: any) {
        if (event) {
            const date = toUTCSmallDate(event);
            this.from = date;
            // this.startDatePicker._select(date);
            // this.fromDate.nativeElement.value = moment(date).locale('fr').format('L');
            this.refresh();
        }
    }

    changeTo(event: any) {
        if (event) {
            const date = toUTCSmallDate(event);
            this.to = date;
            // this.endDatePicker._select(date);
            // this.toDate.nativeElement.value = moment(date).locale('fr').format('L');
            this.refresh();
        }
    }
//#endregion Dates

    refresh() {
        const query: TransactionsQuery = {
            statut: this.statut,
            type: this.type,
            from: this.from,
            to: this.to,
        };
        this.paginator._pageIndex = 0;
        this.transacsService.getTransactions(query);
    }


    exportCSV() {

        const url = environment.apiUrl + '/transactions/export' +
            '?statut=' + (this.statut || '') +
            '&type=' + (this.type || '') +
            '&from=' + this.from.toISOString() +
            '&to=' + this.to.toISOString();
        this.nativeWindow.open(url);

    //   this.dialogRef = this.dialog.open(TransactionsExportFormDialogComponent, {
    //     panelClass: 'event-form-dialog',
    //     data: {
    //       action: 'new',
    //       date: this.selectedDates
    //     }
    //   });
    //   this.dialogRef.afterClosed()
    //     .subscribe((response: FormGroup) => {
    //       if ( !response )
    //       {
    //           return;
    //       }
    //       const newEvent = response.getRawValue();
    //       console.log(newEvent.start);
    //       console.log((newEvent.start as Date).getTime());
    //       console.log(newEvent.end);
    //       console.log((newEvent.end as Date).getTime());

    //       const url = environment.apiUrl + '/transactions/export' +
    //         '?from=' + (newEvent.start as Date).getTime() +
    //         '&to=' + (newEvent.end as Date).getTime();

    //       const newWindow = this.nativeWindow.open(url);
    //       // newEvent.actions = this.actions;
    //       // this.events.push(newEvent);
    //       // this.refresh.next(true);
    //     });
    }

    storePaginatorState() {
        window.localStorage.setItem('currentPageNumber', this.paginator.pageIndex.toString());
        window.localStorage.setItem('currentPageLength', this.paginator.pageSize.toString());
    }


}

export class FilesDataSource extends DataSource<any>
{
    _filterChange = new BehaviorSubject('');
    _filteredDataChange = new BehaviorSubject('');

    get filteredData(): any
    {
      return this._filteredDataChange.value;
    }

    set filteredData(value: any)
    {
      this._filteredDataChange.next(value);
    }

    get filter(): string
    {
      return this._filterChange.value;
    }

    set filter(filter: string)
    {
      this._filterChange.next(filter);
    }

    constructor(
      private transactionsService: TransacsService,
      private _paginator: MatPaginator,
      private _sort: MatSort
    ) {
      super();
      this.filteredData = this.transactionsService.transactions;
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<any[]> {
      const displayDataChanges = [
        this.transactionsService.onTransactionsChanged,
        this._paginator.page,
        this._filterChange,
        this._sort.sortChange
      ];

      return Observable.merge(...displayDataChanges).map(() => {
        let data = this.transactionsService.transactions.slice();

        data = this.filterData(data);

        this.filteredData = [...data];

        data = this.sortData(data);

        // Grab the page's slice of data.
        const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
        return data.splice(startIndex, this._paginator.pageSize);
      });
    }

    filterData(data)
    {
      if ( !this.filter )
      {
        return data;
      }
      return FuseUtils.filterArrayByString(data, this.filter);
    }

    sortData(data): any[]
    {
        if ( !this._sort.active || this._sort.direction === '' )
        {
          return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch ( this._sort.active )
            {

            //   case 'libelle':
            //     [propertyA, propertyB] = [a.libelle, b.libelle];
            //     break;
            //   case 'ville':
            //     [propertyA, propertyB] = [a.ville, b.ville];
            //     break;
            //   case 'telephone':
            //     [propertyA, propertyB] = [a.telephone, b.telephone];
            //     break;
            //   case 'email':
            //     [propertyA, propertyB] = [a.email, b.email];
            //     break;
            //   case 'createdAt':
            //     [propertyA, propertyB] = [a.createdAt, b.createdAt];
            //     break;
            //   case 'dateSubmited':
            //     [propertyA, propertyB] = [a.dateSubmited, b.dateSubmited];
            //     break;
            //   case 'dateValidated':
            //       const aValue = (a.dateValidated) ? 1 : (!a.invalid) ? 0 : -1;
            //       const bValue = (b.dateValidated) ? 1 : (!b.invalid) ? 0 : -1;
            //       [propertyA, propertyB] = [aValue, bValue];
            //       break;
              /*
              case 'price':
                  [propertyA, propertyB] = [a.priceTaxIncl, b.priceTaxIncl];
                  break;
                  break;
              case 'active':
                  [propertyA, propertyB] = [a.active, b.active];
                  break; */
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }

    getTotalCost() {
      return this.transactionsService.transactions.map(t => t.vads_amount).reduce((acc, value) => acc + value, 0);
    }

    getTotalVAT() {
      return this.transactionsService.transactions.map(t => t.amountVAT).reduce((acc, value) => acc + value, 0);
    }

    disconnect()
    {
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/transactions/transactions.component.ts